import { createRouter, createWebHistory } from 'vue-router';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import UserManagement from '../views/UserManagement.vue';
import PlaylistList from '../views/PlaylistList.vue';
import SongManagement from '../views/SongManagement.vue';
import EmotionManagement from '../views/EmotionManagement.vue';
import BuildPack from '../views/BuildPack.vue';
import DeviceManagement from '../views/DeviceManagement.vue';
import AuditLog from '../views/AuditLog.vue';
import Profile from '../views/Profile.vue';
import DeviceRoleSetting from '@/views/DeviceRoleSetting.vue'
import DeviceBoard from '@/views/DeviceBoard.vue';
import DeviceSchedule from '@/views/DeviceSchedule.vue';
import EmotionMarket from '@/views/EmotionMarket.vue';
import ThemeManagement from '@/views/ThemeManagement.vue';
import MenuManagement from '@/views/MenuManagement.vue';
import WeatherManagement from '@/views/WeatherManagement.vue';
import AnnouncementManagement from '@/views/AnnouncementManagement.vue';
import BoardTypeManagement from '@/views/BoardTypeManagement.vue';
import FirmwareManagement from '@/views/FirmwareManagement.vue';
import IotServerApiDoc from '@/views/IotServerApiDoc.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: { requiresAuth: false }
  },
  {
    path: '/market',
    name: 'EmotionMarket',
    component: EmotionMarket,
    meta: { requiresAuth: false }
  },
  {
    path: '/',
    redirect: '/market'
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    meta: { requiresAuth: true }
  },
  {
    path: '/users',
    name: 'UserManagement',
    component: UserManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/playlists',
    name: 'PlaylistList',
    component: PlaylistList,
    meta: { requiresAuth: true }
  },
  {
    path: '/playlist-categories',
    name: 'PlaylistCategoryManagement',
    component: () => import('@/views/PlaylistCategoryManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/playlist-tags',
    name: 'PlaylistTagManagement',
    component: () => import('@/views/PlaylistTagManagement.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/songs',
    name: 'SongManagement',
    component: SongManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/packs',
    name: 'EmotionManagement',
    component: EmotionManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/packs/build',
    name: 'BuildPack',
    component: BuildPack,
    meta: { requiresAuth: true }
  },
  {
    path: '/devices',
    name: 'DeviceManagement',
    component: DeviceManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/audit',
    name: 'AuditLog',
    component: AuditLog,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/deviceRoleSetting',
    name: 'DeviceRoleSetting',
    component:  DeviceRoleSetting ,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/deviceBoard',
    name: 'DeviceBoard',
    component:  DeviceBoard ,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/deviceSchedule',
    name: 'DeviceSchedule',
    component: DeviceSchedule ,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/themes',
    name: 'ThemeManagement',
    component: ThemeManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/menus',
    name: 'MenuManagement',
    component: MenuManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/weather',
    name: 'WeatherManagement',
    component: WeatherManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/announcements',
    name: 'AnnouncementManagement',
    component: AnnouncementManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/board-types',
    name: 'BoardTypeManagement',
    component: BoardTypeManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/firmwares',
    name: 'FirmwareManagement',
    component: FirmwareManagement,
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/iot-server-api-doc',
    name: 'IotServerApiDoc',
    component: IotServerApiDoc,
    // 文档页面：不需要登录也可访问，因此不启用认证/管理员限制
    meta: { requiresAuth: false }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token');
  let user = {};
  try {
    const userStr = localStorage.getItem('user');
    if (userStr && userStr !== 'undefined') {
      user = JSON.parse(userStr);
    }
  } catch (e) {
    user = {};
  }
  
  // 如果已登录且访问登录页，重定向到来源页面或仪表盘
  if (to.path === '/login' && token) {
    const redirect = to.query.redirect;
    if (redirect && typeof redirect === 'string') {
      next(redirect.startsWith('/') ? redirect : `/${redirect}`);
    } else {
      next('/dashboard');
    }
    return;
  }
  
  // 检查是否需要认证
  if (to.meta.requiresAuth && !token) {
    // 保存来源页面，登录后跳转回来
    next({
      path: '/login',
      query: { redirect: to.fullPath }
    });
    return;
  }
  
  // 检查是否需要管理员权限
  if (to.meta.requiresAdmin && user.role !== 'admin') {
    next('/dashboard');
    return;
  }
  
  next();
});

export default router;
